export const SUBMITTED_TO_LENDER_STATUSES: string[] = [
  'RETURN_FROM_UW',
  'UW_PROCESSING',
  'APPLICATION_COMPLETE',
  'APPLICATION_COMPLETE_PORTAL',
  'APPLICATION_AT_LENDER',
];
